import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Investment from "./views/Investment";
import Contact from "./views/Contact";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/portfolio',
      name: 'portfolio',
      beforeEnter(to, from, next) {
        window.location.replace("https://jovanaivic.pic-time.com/portfolio")
      }
    },
    {
      path: '/investment',
      name: 'investment',
      component: Investment
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: Investment
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/404',
      name: '404',
      component: () => import(/* webpackChunkName: "404" */ './components/NotFound.vue')
    },
    {
      path: '*', component: () => import(/* webpackChunkName: "404" */ './components/NotFound.vue')
    }
  ]
})
